import Model, { attr } from '@ember-data/model';
import {
  journalGoalLabels,
  oneTimeGoalTypeId,
} from 'donor-elf-web/lib/journal-goal-utils';

export default class JournalGoalModel extends Model {
  @attr('number') declare goalTypeId: number;
  @attr('number') declare amount: number;
  @attr('number') weeklyGoal?: number;

  get goalTypeLabel(): string {
    return journalGoalLabels[this.goalTypeId];
  }

  get oneTimeGoalType() {
    return this.goalTypeId === oneTimeGoalTypeId;
  }
}
